export default "<div class=\"overlay\">\n    <div class=\"lds-hourglass\"></div>\n</div>\n    "